import { Button, Grid, TextField, Theme } from '@mui/material';
import _ from 'lodash';
import React from 'react';
import { Image, Spinner } from 'react-bootstrap';
import ButtonUploadImage, { FileT } from '../../../../../components/ButtonUploadImage';

import { uploadFileServer } from '../../../../../utils/RequestMethods';
import colors from '../../../../../constants/colors';
import { createStyles, makeStyles } from '@mui/styles';
import { DisputImageLineItemT } from '../../../../../types/Dispute';


const useStyles = makeStyles((theme: Theme) => createStyles({
    imageContainer: {
        position: "relative",
        border: "1px solid #ccc",
        height: 200,
        width: 200,

        marginBottom: 0,
        "&:hover,&:active,&:focus": {
            borderStyle: "dashed",
            borderColor: colors.blue_2,
            cursor: "pointer",
            "& .button-upload": {
                zIndex: 5,
                backgroundColor: colors.blue_2,
                color: colors.white,
            },
            "& .hide": {
                display: "block",
            }
        },
        "& .image": {
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%", height: "100%",
            zIndex: 2
        },
        "& .button-upload": {
            position: "absolute",
            top: "50%",
            left: "44%",
            zIndex: 1,
            border: "1px solid #ccc",
            borderRadius: 20,
            height: 30,
            width: 30,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: colors.blue_2,
        },
        "& .hide": {
            display: "none",
        },
        "& .box-spinner": {
            position: "absolute",
            top: "50%",
            left: "44%",
            zIndex: 40,
            border: "1px solid #ccc",
            borderRadius: 20,
            height: 30,
            width: 30,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: colors.blue_2,
        },
    },
    inputCommant: {
        height: "100%",
        "& .MuiFilledInput-root": {
            height: "100%",
        },
        "& .MuiInput-root": {
            height: "100%",
        },

    }
}))



export type IDisputImageLineItemProps = {
    item: DisputImageLineItemT
    index: number
    updateLineItem(index: number, item: DisputImageLineItemT): void
    removeLineItem(index: number): void
}

const DisputImageLineItem: React.FC<IDisputImageLineItemProps> = (props) => {
    const [tempFile, setTempFile] = React.useState<FileT | null>(null);
    const [processing, setProcessing] = React.useState(false);

    const classes = useStyles()

    const onChangeValue = (key: string, value: any) => {
        let cloneItem = _.cloneDeep(props?.item)
        cloneItem[key] = value
        props.updateLineItem(props.index, cloneItem)
    }
    // console.log("props?.item", props.item)
    return (
        <div className='d-flex flex-row p-2' style={{ gap: 50, position: "relative" }}>
            <div className='d-flex flex-column' style={{ gap: 2 }}>
                <ButtonUploadImage

                    type="button"

                    //default={false}
                    accept={"image/png, image/jpeg"}
                    className={`${classes.imageContainer}`}
                    onChangeFile={async (file) => {
                        setTempFile(file)
                        setProcessing(true)
                        uploadFileServer(file).then((res) => {
                            setProcessing(false)
                            if (res.source_url) {
                                onChangeValue("image", res.source_url)
                            }
                        }).catch((error) => {
                            setProcessing(false)
                        })
                        // addNewImage(file)
                    }}>
                    <div style={{ width: "100%", height: "100%" }}>
                        {(tempFile?.uri || props?.item?.image) && <Image
                            rounded
                            src={tempFile?.uri ? tempFile?.uri : props?.item?.image}
                            className='image'
                        />}
                    </div>
                    <div className={`button-upload ${tempFile?.uri || props?.item?.image ? "hide" : ""}`}>
                        <i className='fa fa-upload' />
                    </div>
                    {processing && <div className='box-spinner'>
                        <Spinner animation='border' />
                    </div>}
                </ButtonUploadImage>
                {/* {tempFile && <div className='d-flex flex-row ' style={{ gap: 2 }}>
                    <Button variant='outlined' onClick={() => {
                        setTempFile(null)
                    }}>
                        Cancel
                    </Button>
                    <Button variant='contained'>
                        Save Image
                    </Button>
                </div>} */}
            </div>
            <div className='w-100 d-flex flex-column' style={{ gap: 3 }}>
                <div className='d-flex'>
                    <h4>{`Exhibit ${props?.index + 1}`}</h4>
                </div>
                <div className='w-100 h-100 d-flex flex-fill'>
                    <TextField
                        variant="standard"
                        className={`${classes.inputCommant}`}
                        // classes={{
                        //     root: classes.inputCommant
                        // }}

                        fullWidth
                        multiline
                        rows={7}
                        placeholder="Exhibit comment"
                        value={props?.item?.notes}
                        onChange={(event: any) => {
                            let value = event.target.value
                            onChangeValue("notes", value)
                        }}
                    />
                </div>
            </div>
            <div style={{
                position: "absolute",
                top: -2,
                right: -3,
                // border: "1px solid #cc0000",
                borderRadius: 20,
                height: 30,
                width: 30,
                display: "flex",
                cursor: "pointer"
            }}
                onClick={() => props.removeLineItem(props.index)}>
                <div className='w-100 d-flex justify-content-center align-items-center'>
                    <i className='fa fa-close' style={{ color: colors.red }} />
                </div>
            </div>
        </div>
    );
}

export default DisputImageLineItem